import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface ClientItem {
  id: string;
  filename?: string | null;
  [key: string]: any;
}

interface ClientsState {
  items: ClientItem[];
  loading: boolean;
  error: string | null;
}

const initialState: ClientsState = {
  items: [],
  loading: false,
  error: null,
};

// React Native specific download function (commented out for web)
// const folder = '/logos/';
// const downloadFiles = (payload: { clients: ClientItem[] }) => {
//   payload.clients.forEach((client) => {
//     if (client.filename !== null) {
//       // RNFS.exists(folder + client.filename).then((exists) => {
//       //   if (!exists) {
//       //     RNFS.downloadFile({
//       //       fromUrl: ref.APP_URL + "/attachment/" + client.filename,
//       //       toFile: folder + client.filename,
//       //       discretionary: true,
//       //       cacheable: true,
//       //     }).catch((err) => {
//       //       console.log(err.message, err.code);
//       //     });
//       //   }
//       // }).catch((err) => {
//       //   console.log(err.message, err.code);
//       // });
//     }
//   });
// };

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    // Other actions can be added here if needed
  },
  extraReducers: (builder) => {
    // Handle data from GET_BOOKINGS_COMMIT
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      clients?: ClientItem[];
      bookings?: any[];
      [key: string]: any;
    }>) => {
      const { clients } = action.payload;
      const { meta } = action as any;

      // React Native file download logic would go here
      // RNFS.mkdir(folder).then(() => {
      //   downloadFiles(action.payload);
      // }).catch((err) => {
      //   console.log(err.message, err.code);
      //   downloadFiles(action.payload);
      // });

      const isPagedRequest = meta && meta.page !== undefined && meta.page > 0;

      if (isPagedRequest) {
        if (clients && clients.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, clients);
        }
      } else {
        // First page load or refresh - replace all clients
        state.items = clients || [];
      }
    });
  },
});

export const {
  // Actions will be exported here if needed
} = clientsSlice.actions;

export default clientsSlice.reducer;